import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Drawer, DrawerContent, DrawerHeader, DrawerBody, DrawerFooter, Button, useDisclosure } from '@heroui/react';
import last_known_icon from '../../../assets/map-legend-images/Last_Known.png';
import analysed_track_icon from '../../../assets/map-legend-images/Analysed_Track.png';
import raw_track_icon from '../../../assets/map-legend-images/Raw_Track.png';
import vessel_stop_icon from '../../../assets/map-legend-images/Vessel_Stop.png';
import port_call_load_icon from '../../../assets/map-legend-images/Port_Call_Load.png';
import port_call_discharge_icon from '../../../assets/map-legend-images/Port_Call_Discharge.png';
import port_call_unclassified_icon from '../../../assets/map-legend-images/Port_Call_Unclassified.png';
import port_call_shipyard_icon from '../../../assets/map-legend-images/Port_Call_Shipyard.png';

export default function MapLegendInfo() {
	const { isOpen, onOpen, onOpenChange } = useDisclosure();

	const mapLegendContent = [
		{
			id: 'last_known',
			image: last_known_icon,
			text: 'Last known ship location (colour denotes sector)',
			class: 'h-3',
		},
		{
			id: 'analysed_track',
			image: analysed_track_icon,
			text: 'Vessel Track over past 12 months (fully analysed)',
			class: 'h-3',
		},
		{
			id: 'raw_track',
			image: raw_track_icon,
			text: 'Vessel Track since end of previous month (raw)',
			class: 'h-3',
		},
		{
			id: 'vessel_stop',
			image: vessel_stop_icon,
			text: 'Vessel Stop',
			class: 'h-3',
		},
		{
			id: 'port_call_load',
			image: port_call_load_icon,
			text: 'Port Call (Activity: Load)',
			class: 'h-6',
		},
		{
			id: 'port_call_discharge',
			image: port_call_discharge_icon,
			text: 'Port Call (Activity: Discharge)',
			class: 'h-6',
		},
		{
			id: 'port_call_unclassified',
			image: port_call_unclassified_icon,
			text: 'Port Call (Activity: Unclassified)',
			class: 'h-6',
		},
		{
			id: 'port_call_shipyard',
			image: port_call_shipyard_icon,
			text: 'Shipyard Visit',
			class: 'h-6',
		},
	];

	const renderDrawerContent = (mapLegendContent: { id: string; image: string; text: string; class: string }[]) => {
		return mapLegendContent.map((item) => (
			<div key={item.id} className="flex items-center space-x-2 p-2 rounded-md bg-gray-100">
				<div className="flex justify-center items-center w-10">
					<img className={item.class} src={item.image} alt={item.text} />
				</div>
				<span className="text-gray-700 text-sm flex-1 text-left">{item.text}</span>
			</div>
		));
	};

	return (
		<>
			{/* <Button isIconOnly onPress={onOpen}>Open Drawer</Button> */}
			<div className="absolute z-10 opacity-85" style={{ bottom: 38, right: 44 }}>
				<Button
					isIconOnly
					style={{ backgroundColor: '#FFFFFF', width: '48px', height: '28px' }}
					className="rounded h-[30px] w-[30px]"
					//size="sm"
					onPress={onOpen}
					color="default"
					title="Map Legend"
				>
					<FontAwesomeIcon size="xl" icon={faCircleInfo} />
				</Button>
			</div>
			<Drawer
				size="xs"
				isOpen={isOpen}
				onOpenChange={onOpenChange}
				className="top-16 bottom-10 rounded-none"
				classNames={{ closeButton: 'rounded' }}
			>
				<DrawerContent>
					{(onClose) => (
						<>
							<DrawerHeader className="flex flex-col gap-1">Map Legend</DrawerHeader>
							<DrawerBody>{renderDrawerContent(mapLegendContent)}</DrawerBody>
							<DrawerFooter>
								<Button color="danger" size="sm" className="rounded" variant="light" onPress={onClose}>
									Close
								</Button>
							</DrawerFooter>
						</>
					)}
				</DrawerContent>
			</Drawer>
		</>
	);
}
